<div class="activity-timeline" *ngIf="displayActivities?.length; else emptyTimeline">
    <div
            class="timeline-step"
            *ngFor="let activity of displayActivities; let i = index"
            [class.timeline-step-last]="isLast(i)">
        <div class="timeline-rail">
            <span class="timeline-node" [ngClass]="getState(i)"></span>
            <span class="timeline-connector" *ngIf="!isLast(i)"></span>
        </div>
        <article class="timeline-card" [ngClass]="getState(i)">
            <header class="timeline-card-header">
                <h5>{{ activity.title }}</h5>
                <span class="timeline-meta" *ngIf="activity.created_at">
                    {{ activity.created_at | date: 'dd/MM/yyyy HH:mm' }}
                </span>
            </header>
            <p class="timeline-description">{{ activity.description || '-' }}</p>
            <footer class="timeline-footer" *ngIf="activity.created_by_name">
                <span>{{ activity.created_by_name }}</span>
            </footer>
        </article>
    </div>
</div>

<ng-template #emptyTimeline>
    <div class="timeline-empty">No activity recorded yet.</div>
</ng-template>
